"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateTransaction = void 0;
const consts_1 = require("../../consts");
const u_1 = require("../../u");
const components_1 = require("../components");
const BaseTransaction_1 = require("./BaseTransaction");
const TransactionType_1 = __importDefault(require("./TransactionType"));
/**
 * Transaction used for invoking smart contracts through a VM script.
 * Can also be used to transfer UTXO assets.
 */
class StateTransaction extends BaseTransaction_1.BaseTransaction {
    constructor(obj = {}) {
        super(Object.assign({ version: consts_1.TX_VERSION.STATE }, obj));
        this.type = TransactionType_1.default.StateTransaction;
        this.descriptors = obj.descriptors
            ? obj.descriptors.map((d) => new components_1.StateDescriptor(d))
            : [];
    }
    static deserializeExclusive(ss, tx) {
        const out = {
            descriptors: [],
        };
        const descLength = ss.readVarInt();
        for (let i = 0; i < descLength; i++) {
            out.descriptors.push(components_1.StateDescriptor.fromStream(ss));
        }
        return Object.assign(tx, out);
    }
    get exclusiveData() {
        return { descriptors: this.descriptors };
    }
    get fees() {
        return 0;
    }
    serializeExclusive() {
        let out = u_1.num2VarInt(this.descriptors.length);
        out += this.descriptors.map((d) => d.serialize()).join("");
        return out;
    }
    equals(other) {
        if (this.type !== other.type) {
            return false;
        }
        if (other instanceof StateTransaction) {
            return this.hash === other.hash;
        }
        return this.hash === new StateTransaction(other).hash;
    }
    export() {
        return Object.assign(super.export(), {
            descriptors: this.descriptors.map((d) => d.export()),
        });
    }
}
exports.StateTransaction = StateTransaction;
exports.default = StateTransaction;
